<div class="calculator">
	<input type="text" class="calculator-screen" [value]="currentNumber$ | async" [attr.disabled]="true" />

	<div class="calculator-keys" dir="ltr">
		<!-- <button type="button" (click)="getOperation('+')" class="operator" value="">+</button>
        <button type="button" (click)="getOperation('-')" class="operator" value="-">-</button>
        <button type="button" (click)="getOperation('*')" class="operator" value="*">&times;</button>
        <button type="button" (click)="getOperation('/')" class="operator" value="/">&divide;</button> -->

		<button type="button" *ngFor="let number of numbers" (click)="getNumber(number)" [value]="number" class="button">{{ number }}</button>

		<button type="button" (click)="clear()" class="all-clear" value="all-clear" class="button">מחק</button>

		<button type="button" (click)="getNumber('0')" value="0" class="button">0</button>
		<button type="button" (click)="getDecimal()" class="decimal" value="." class="button">.</button>

		<!-- <button type="button" (click)="getOperation('=')" class="equal-sign" value="=" class="button">=</button> -->
	</div>
</div>
